import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import CreatableSelect from 'react-select/creatable'
import {confirm} from 'react-confirm-box'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {CreateData} from '../../../Contacts/Tags/TagSlice/TagsSlices'

const optionsWithLabelChange = {
  closeOnOverlayClick: false,
  labels: {
    confirmable: 'Confirm',
    cancellable: 'Cancel',
  },
}

const AddTagBulk = ({show, handleClose, checkList, setTagAdded}: any) => {
  const dispatch = useDispatch()
  const tagslist = useSelector((state: any) => state?.tags?.allTags?.data)

  const [tag, setTag] = useState<any>([])
  const [selectedTag, setSelectedTag] = useState<any>([])

  useEffect(() => {
    let listData = tagslist
      ?.filter((it: any) => it.type === 'tag')
      .map((val: any) => ({value: val?._id, label: val?.name}))

    setTag(listData)
  }, [tagslist])

  const handleCreate = async (e: any) => {
    // if(/^[a-zA-Z0-9_]{2,25}+$/gm.test(e)){
    let confirNew = await confirm(
      'Are you sure you want to create a new tag?',
      optionsWithLabelChange
    )
    setSelectedTag([...selectedTag, {value: e, label: e}])
    confirNew &&
      dispatch(
        CreateData({
          name: e,
        })
      )
    // }
  }

  const handleChange = async (e: any) => {
    setSelectedTag(e)
  }

  const handleSubmmit = () => {
    let Findids = tagslist
      ?.map((val: any) => {
        if (selectedTag?.find((key: any) => key?.label == val?.name) !== undefined) {
          return val?._id
        }
      })
      ?.filter((key: any) => key !== undefined)

    setTagAdded(Findids)
    handleClose()
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} dialogClassName='modal-dialog-centered mw-500px'>
        <div className='modal-header'>
          <h2>Tag contact</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
          </div>
        </div>
        <div className='modal-body'>
          <label className='col-form-label fw-bold fs-6'>Tag name</label>
          <CreatableSelect
            onCreateOption={handleCreate}
            isOptionSelected={selectedTag}
            value={selectedTag}
            isMulti
            options={tag}
            onChange={handleChange}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base: any) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
          />
        </div>
        <div className='modal-footer d-flex justify-content-end m-0'>
          <button onClick={handleClose} type='button' className='btn btn-light-primary'>
            Cancel
          </button>
          <button onClick={handleSubmmit} id='submit' type='button' className='btn btn-primary'>
            Submit
          </button>
        </div>
      </Modal>
    </>
  )
}

export default AddTagBulk
